const pais = {
  path: "/pais",
  redirect: "/pais",
  component: () => import("@/layout/Layout.vue"),
  children: [
    {
      path: "/pais/novo",
      name: "pais_novo",
      component: () => import("@/views/Pais/PaisCad.vue"),
    },
    {
      path: "/pais/edit/:id",
      name: "pais_atualizar",
      component: () => import("@/views/Pais/PaisEdit.vue"),
    },
    {
      path: "/pais",
      name: "pais",
      component: () => import("@/views/Pais/PaisHome.vue"),
    },
  ],
};

export { pais };
